/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {FormattedMessage, injectIntl} from 'react-intl';
import {Card, List, Tooltip} from '@scuf/common';
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import * as FaultActions from "../FaultActions";
import {formatDateTime} from "../../common/LocaleHelper";
import {FAULT_STATES} from "../common/FaultsConst";
import {getFaultName} from "../../utils/Helpers";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import {getReadOnlyStatus} from "../common/FaultsUtils";

class FaultCard extends React.Component {

    goToFault(fault) {
        const {history, userProfile} = this.props
        this.props.FaultActions.clearState();
        userHasActivity(userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ?
            history.push(`/airtime/asset/${fault.asset.id}/faults/${fault.id}/troubleshooting`)
            :
            history.push(`/assets/${fault.asset.id}/faults/${fault.id}/troubleshooting`)
    }

    getSymptomItems(symptoms) {
        return symptoms.map(s => <List.Content key={s.id}>{s.name}</List.Content>)
    }

    getLLExportedStatus() {
        const {fault, intl} = this.props

        if (fault.exportedLL) {
            return <span className="ll-exported" title={intl.formatMessage({id: "fault.detail.label.exportedLL"}) + " " + formatDateTime(fault.exportedLL)}><FormattedMessage id="fault.card.label.exported" /></span>
        }
        return null
    }

    render() {
        const {fault, intl} = this.props
        const faultName = getFaultName(fault)
        // Fault with name starting 'Alert#' and with NEW state will be on UI shown with state 'NEW_ALERT' (this state doesn't really exist in DB)
        let newFaultState = fault.faultConditionState
        if((fault.name.startsWith('Alert#')) && (newFaultState === FAULT_STATES.NEW)) {
            newFaultState = FAULT_STATES.NEW_ALERT;
        }
        return (
            <Card onClick={() => this.goToFault(fault)} className={'fault-card state-' + newFaultState}>
                <Card.Header>
                    <div className='state-icon' />
                    <div className='fault-name'>
                        {faultName}
                    </div>
                    {fault.assignedUser !== null ?
                        <Tooltip
                            element={<div className='assignee' title={fault.assignedUser.displayName}>{fault.assignedUser.firstName.charAt(0) + fault.assignedUser.lastName.charAt(0)}</div>}
                            content={fault.assignedUser.firstName + " " + fault.assignedUser.lastName}
                            position="top right"
                            event="hover"
                            hoverable={true}
                            hideOnScroll={true}
                            size="mini"
                        />
                        :
                        null
                    }
                </Card.Header>
                <Card.Meta>
                    <div className="asset-name"> {fault.asset.name}</div>
                    {intl.formatMessage({id: "fault.detail.label.created"})} {formatDateTime(fault.created)}
                    <div/>
                    <div className='state-name'>{intl.formatMessage({id: "fault.detail.state." + newFaultState})}
                        {fault.closed != null ? ": " + formatDateTime(fault.closed) : null}
                    </div>
                    {this.getLLExportedStatus()}
                    {getReadOnlyStatus(this.props)}
                </Card.Meta>
                <Card.Content>
                    <List bulleted>
                        {this.getSymptomItems(fault.reportedSymptoms)}
                    </List>
                </Card.Content>
                <Card.Footer>
                </Card.Footer>
            </Card>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        security: state.security,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(FaultCard)))